export enum GoalPanelType {
    TextBasedGoals = 1,
    NumericGoals = 2,
    CompetencyResult = 3,
    CustomGoals = 4,
    GroupGoals = 5,
}